import { ICompanyMetadataPure } from '../../common/models/CompanyMetadata'
import { GET_COMPANY_METADATA } from '../../constants/api'
import errorHandler from './errorHandler'

// Request company metadata
export default (token: string, termNumber: number) =>
  fetch(GET_COMPANY_METADATA(termNumber), {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then(errorHandler)
    .then(
      async (companyResponse: Response): Promise<ICompanyMetadataPure> => {
        const metaData = await companyResponse.json()
        return metaData
      }
    )
